import { useState, useEffect } from "react";

function useMeasure(ref: React.RefObject<HTMLElement>): DOMRect | null {
  const [measurements, setMeasurements] = useState<DOMRect | null>(null);

  useEffect(() => {
    const element = ref.current;

    if (element) {
      const resizeObserver = new ResizeObserver(([entry]) => {
        setMeasurements(entry.contentRect);
      });

      resizeObserver.observe(element);

      return () => {
        resizeObserver.unobserve(element);
      };
    }
  }, [ref]);

  return measurements;
}

export { useMeasure };
